<!--监控视频广播组件 -->
<template>
  <div id="voice-broadcast" class="pop">
    <div class="voice">
      <div class="log-title">
        <span class="title-name">{{ $t('radioBroadcast') }}</span>
        <div @click="infinityVoice" class="close-voice">
          <img
            class="close"
            :src="
              require(theme === 'default' ? '@/icon/re-new-monitor/ic_hide.png' : '@/icon/re-new-monitor/ic_hide-m.png')
            "
            alt=""
          />
          <span>{{ $t('hide') }}</span>
        </div>
      </div>
      <el-container>
        <el-main>
          <div id="log">
            <div class="chat" ref="chatContent">
              <!-- 聊天记录 -->
              <div class="waveform" ref="waveform" v-for="(item, index) in lists" :key="index">
                <div class="message-row-right">
                  <audio controls autoplay id="audio" ref="audioUrlRefText" :src="fileUrl"></audio>
                  <div class="portrait">
                    <!-- {{ item.userName != '' ? item.image : '我' }} -->
                  </div>

                  <div class="info-chat" v-if="item.type === 0">
                    <div class="nick-time">{{ item.time }}</div>
                    <Trigger
                      class="info-chat-trigger"
                      @playAudioHandler="playAudioHandler"
                      :style="widthPercent(item.length)"
                      :recordType="recordType"
                      :index="index"
                      :isPlaying="isPlaying"
                      :playKey="playKey"
                      :item="item"
                      :currenData="item"
                      :userid="userid"
                    >
                    </Trigger>
                  </div>
                  <div class="text-chat" v-if="item.type === 1">
                    <div class="nick-time">{{ item.time }}</div>
                    <div class="message-alert">
                      <div>{{ item.content }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 国标智能安全帽 不具备 文字输入转语音的功能，屏蔽入口  -->
            <!-- 当设备在录音禁用文字输入和语音输入 -->
            <div
              class="input-type"
              align="center"
              :style="voiceNow || $store.getters.isOnlySupportIPC ? 'display: none;' : ''"
            >
              <div @click="inputTypeVoice = !inputTypeVoice">
                <img src="@/icon/voice/ic_wenzi.png" v-show="inputTypeVoice" />
                <img src="@/icon/voice/ic_yuyin.png" v-show="!inputTypeVoice" />
                <span>{{ inputTypeVoice ? $t('TextInput') : $t('VoiceInput') }}</span>
                <img v-if="theme === 'default'" src="@/icon/voice/ic_arrow.png" />
                <img v-else src="@/icon/voice/ic_arrow-m.png" />
              </div>
            </div>
          </div>
          <div class="input-text" v-show="!inputTypeVoice">
            <!-- 文字 -->
            <el-row>
              <el-col :span="19"
                ><div>
                  <el-input
                    type="textarea"
                    :rows="4"
                    maxlength="100"
                    :placeholder="$t('enterTextExcept')"
                    v-model="sendInputText"
                  >
                  </el-input></div
              ></el-col>
              <el-col :span="5"
                ><div>
                  <img
                    src="@/icon/voice/word_send.png"
                    v-if="theme === 'default'"
                    class="send-text-btn"
                    @click="send_text"
                  />
                  <img
                    src="@/icon/voice/ic_word_send.png"
                    v-if="theme === 'dark'"
                    class="send-text-btn"
                    @click="send_text"
                  /></div
              ></el-col>
            </el-row>
          </div>
          <div class="talk" v-show="inputTypeVoice">
            <!-- 语音 -->
            <div class="loader"><Ripple v-if="recording"></Ripple></div>
            <div
              class="play-icon"
              :class="theme === 'default' ? 'play-light' : 'play-dark'"
              v-if="news_img"
              @click="handleBtnClick"
              @mouseenter="changeImageSrc('hover')"
              @mouseleave="changeImageSrc('')"
            ></div>
            <div
              class="play-icon"
              v-if="endPlay"
              :class="theme === 'default' ? 'endPlay-light' : 'endPlay-dark'"
              @click="cancel_mp3"
              @mouseenter="changeIcon('in')"
              @mouseleave="changeIcon('out')"
            ></div>
            <div class="send-cancel" v-if="sendCancel">
              <img
                @click="send_voice"
                class="send-btn"
                v-if="theme === 'default'"
                src="@/icon/voice/word_send.png"
                alt=""
              />
              <img
                @click="cancel"
                class="cancel-btn"
                v-if="theme === 'default'"
                src="@/icon/voice/record_cancel.png"
                alt=""
              />
              <!-- 深色 -->
              <img
                @click="send_voice"
                class="send-btndark"
                v-if="theme === 'dark'"
                src="@/icon/voice/ic_word_send.png"
                alt=""
              />
              <img
                @click="cancel"
                class="cancel-btndark"
                v-if="theme === 'dark'"
                src="@/icon/voice/ic_record_cancel.png"
                alt=""
              />
            </div>
            <div class="stop-talk" v-if="stopTip">
              {{ $t('VoiceWillBe') }} {{ stopMinutes }} {{ $t('stopRecording') }}
            </div>
          </div>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
import Recorderx, { ENCODE_TYPE } from 'recorderx'
const rc = new Recorderx()
import { uploadFile, getSelectList, getVoiceList, refreshVoice, uploadText } from '@/api/voiceBroadcast'
import { errorCollection } from '@/api/dmp/dmpCollection'
import store from '../../store/index'
import Ripple from '@/components/voice/ripple'
import { getSession } from '@/api/common'
import Trigger from '@/components/voice/trigger'
export default {
  name: 'VoiceBroadcast',
  props: {
    value: Boolean,
    listPlay: {
      type: Array,
    },
  },
  data() {
    return {
      news_img: true,
      chatList: [], // 聊天信息展示数据
      title: '',
      userName: '',
      searchData: [],
      setAlertVisible: false,
      ouTreeProps: {
        label: 'name',
        children: 'children',
      },
      ouList: [],
      recording: false,
      // 显示语音结束icon
      endPlay: false,
      // 显示取消发送语音icon
      sendCancel: false,
      fileUrl: '',
      fileTime: '',
      isPlaying: false,
      PlayId: '',
      playKey: null,
      editType: '',
      audioTime: 0,
      minutes: 0,
      clearTime: '',
      pageSize: 30,
      pageNum: 1,
      lists: [],
      // 语音记录页数
      totalPages: '',
      userid: getSession('userId'),
      hoverIndex: -1,
      theme: localStorage.getItem('theme'),
      lastTime: 0,
      IsScroll: true,
      lastScrollHeight: 0,
      // 倒计时参数
      clearaudioTime: '',
      // 倒计时显示时间
      stopMinutes: 9,
      // 语音倒计时提示
      stopTip: false,
      recordType: 1,
      //用户
      userTableData: [],
      selectUser: [],
      //输入方式
      inputTypeVoice: true,
      sendInputText: '',
      //正在录音（全部）状态
      voiceNow: false,
      downCode: 0,
    }
  },
  methods: {
    //发送后更新
    updataSelectList() {
      var that = this
      this.refreshVoiceList('')
      setTimeout(() => {
        that.$nextTick(() => {
          that.$refs.chatContent.scrollTop = that.$refs.chatContent.scrollHeight
        })
      }, 500)
    },
    // 展开广播
    infinityVoice() {
      this.$emit('closeBroad')
      this.$emit('input', false)
      this.$store.commit('voiceShow', false)
    },
    // 点击播放 暂停录音
    playAudioHandler(item, key) {
      var audio = document.getElementById('audio')
      if (this.playKey !== key) {
        this.isPlaying = true
        // 判断语音是否过期
        if (new Date().getTime() > new Date(item.expiryTime).getTime()) {
          this._refreshVoice(item)
        } else {
          document.getElementById('audio').src = item.mediaUrl
          this.timer(item)
        }
        document.getElementById('audio').src = item.mediaUrl
        this.timer(item)
      } else {
        this.isPlaying = !this.isPlaying
        if (this.isPlaying === true) {
          document.getElementById('audio').src = item.mediaUrl
          this.timer(item)
        } else {
          audio.pause()
          clearTimeout(this.clearaudioTime)
        }
      }
      this.playKey = key
      this.PlayId = item.userId
    },
    // 刷新当前点击过期语音
    _refreshVoice(item) {
      let param = { id: item.id }
      refreshVoice(param).then(res => {
        if (res.state === 0) {
          console.log(res)
        }
      })
    },
    // 倒计时语音动画
    timer(item) {
      if (item['length']) {
        this.audioTime = Number(item['length'])
      } else {
        this.audioTime = item
      }
      if (this.audioTime > 0) {
        this.audioTime--
        this.clearaudioTime = setTimeout(() => {
          this.timer(this.audioTime)
        }, 1000)
      } else {
        clearTimeout(this.clearaudioTime)
        this.time = 0
        this.isPlaying = false
      }
    },
    toScrollBottom() {
      setTimeout(() => {
        this.$nextTick(() => {
          try {
            this.lastScrollHeight = this.$refs.chatContent.scrollHeight
            this.$refs.chatContent.scrollTop = this.$refs.chatContent.scrollHeight
            this.$refs.chatContent.style.visibility = 'visible'
            window.addEventListener('scroll', that.handleScroll, true)
          } catch {
            console.log('handleList.err')
          }
        })
      }, 300)
    },
    handleScroll() {
      //监听滚动条加载更多历史录音
      setTimeout(() => {
        this.$nextTick(() => {
          if (this.$refs.chatContent) {
            let scrollTop = this.$refs.chatContent.scrollTop
            if (scrollTop === 0) {
              if (this.IsScroll === true) {
                if (this.pageNum < this.totalPages) {
                  this.pageNum = this.pageNum + 1
                  this._getVoiceList('nowadd')
                  this.IsScroll = false
                }
              }
            }
          }
        })
      }, 1000)
    },
    _getVoiceList(val) {
      // 获取录音列表
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      getVoiceList(param).then(res => {
        if (res.state === 0) {
          if (res.value.content.length > 0) {
            this.totalPages = res.value.totalPages
            this.converList(res.value.content.reverse(), val)
          } else {
            this.lists = []
          }
        }
      })
    },
    converList(data, val) {
      // 通话录音列表
      this.chatList = []
      for (let item of data) {
        if (item.type === 0 || item.type === 1) {
          // item.image = item.userName.split('')[0]
          let data = item.logTimestamp.split(' ')[0]
          let newdata = data.split('-')
          item.time = newdata[1] + '月' + newdata[2] + '日' + item.logTimestamp.split(' ')[1]
          this.chatList.push(item)

          // item.image = item.userName.split('')[0]
          // this.chatList.push(item)
        }
      }
      this.lists = this.chatList.concat(this.lists)
      val !== 'nowadd' ? this.toScrollBottom() : ''
      this.IsScroll = true
      this.handleList()
    },
    handleList() {
      // 历史记录位置不变
      this.$refs.chatContent.scrollTop = this.$refs.chatContent.scrollHeight - this.lastScrollHeight + 10
      this.lastScrollHeight = this.$refs.chatContent.scrollHeight
    },
    _getSelectList(val, id, data) {
      // 查询已有人员/群组列表
      let params = {
        userName: '',
        statusList: [1],
        specType: 1,
      }
      getSelectList(params).then(res => {
        if (res.state === 0) {
          this.searchData = res.data
          if (this.searchData.length > 0) {
            this.deviceListchange(res.data)
          } else {
            this.lists = []
            this.IsScroll = false
          }
          this.refreshVoiceList(data)
        }
      })
    },
    refreshVoiceList(data) {
      this.lists = []
      this.pageNum = 1
      this._getVoiceList(data)
    },
    changeImageSrc(type) {
      if (this.recording === true && type === 'hover') {
        this.endPlay = true
        this.recording = false
      }
    },
    changeIcon(type) {
      // 结束icon变化
      if (type === 'in') {
        this.recording = false
        this.endPlay = true
      } else if (type === 'out' && this.news_img !== false) {
        this.recording = true
        this.endPlay = false
      } else if (type === 'out' && this.news_img === false) {
        this.recording = false
        this.endPlay = false
      }
    },
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    //录制语音
    handleBtnClick: function() {
      if (this.listPlay.length > 0) {
        // 判断是否有人员/广播才可以点击录音
        let that = this
        rc.start()
          .then(() => {
            that.recording = true
            this.endPlay = true
            that.voiceNow = true
            console.log('start recording')
            this.minutes = 0
            this.clearTime = setInterval(this.startTimer, 1000)
          })
          .catch(error => {
            this.$message({
              type: 'error',
              message: this.$t('FailedAcquireMicrophone'),
              customClass: 'zZindex',
              duration: 2000,
            })
            errorCollection('语音通讯', '获取麦克风权限', { status: 200, data: { state: -1, msg: '获取麦克风失败!' } })
            console.log('Recording failed.', error)
          })
      } else {
        this.$message({ type: 'error', message: this.$t('noUsersCanSend') })
        errorCollection('语音通讯', '录制语音', { status: 200, data: { state: -1, msg: '没有可发送语音的用户!' } })
      }
    },
    startTimer() {
      // 开始录音计时
      this.minutes = this.minutes + 1
      if (22 <= this.minutes) {
        // 录音到22秒后 倒计时提示
        this.stopMinutes--
        this.stopTip = true
        // this.stopMinutes = this.stopMinutes
      }
      if (this.minutes >= 30) {
        // 录音到30秒后 录音自动结束
        clearInterval(this.clearTime)
        this.endPlay = false
        this.sendCancel = true
        this.news_img = false
        this.recording = false
        this.stopTip = false
      }
    },
    cancel_mp3: function() {
      this.stopTip = false
      //结束语音
      rc.pause()
      clearInterval(this.clearTime)
      if (this.minutes < 1) {
        // 录音时长小于1 提示
        this.$message({
          type: 'error',
          message: this.$t('RecordingTimeTooShort'),
          duration: 2000,
        })
        this.voiceNow = false
        errorCollection('语音通讯', '录制语音', { status: 200, data: { state: -1, msg: '录音时长太短' } })
        this.endPlay = false
        this.sendCancel = false
        this.news_img = true
        this.recording = false
      } else {
        this.endPlay = false
        this.sendCancel = true
        this.news_img = false
        this.recording = false
      }
    },
    cancel: function() {
      this.stopTip = false
      // 取消语音
      rc.clear()
      this.sendCancel = false
      this.news_img = true
      let audio = this.$refs.audioUrlRefText
      if (audio.readyState > 0) {
        this.fileTime = parseInt(audio.duration % 60)
      }
      this.voiceNow = false
    },
    //发送语音
    send_voice: function() {
      if (this.listPlay.length == 0) {
        return
      }
      this.stopTip = false
      //发送语音
      let now = new Date().valueOf()
      if (this.lastTime === 0) {
        this.lastTime = now
        var wav = rc.getRecord({
          encodeTo: ENCODE_TYPE.WAV,
          compressible: true,
        })
        var formData = new FormData()
        formData.append('file', wav, 'voice.wav')
        formData.append('length', this.minutes)
        for (var item of this.listPlay) {
          formData.append('helmetList', item.serialNumber)
        }
        uploadFile(formData).then(res => {
          if (res.state === 0) {
            rc.clear()
            this.IsScroll = false
            this.updataSelectList()
          }
          this.sendCancel = false
          this.news_img = true
          this.lastTime = 0
        })
        this.voiceNow = false
        window.removeEventListener('scroll', this.handleScroll, true)
      } else {
        console.log('重复点击')
      }
    },
    //发送文字
    send_text: function() {
      if (this.listPlay.length == 0) {
        return
      }
      if (this.sendInputText.trim().length === 0) {
        this.$message({
          message: this.$t('pleaseEnterText'),
          type: 'warning',
        })
        return
      }
      var formData = new FormData()
      for (var item of this.listPlay) {
        formData.append('helmetList', item.serialNumber)
      }
      formData.append('word', this.sendInputText)
      uploadText(formData).then(res => {
        if (res.state === 0) {
          this.sendInputText = ''
          rc.clear()
          this.IsScroll = false
          this.updataSelectList()
        }
        this.sendCancel = false
        this.news_img = true
        this.lastTime = 0
        window.removeEventListener('scroll', this.handleScroll, true)
      })
    },
    //机构-用户 转 用户集合
    deviceListchange: function(data) {
      for (var k in data) {
        if (data[k].children != undefined) {
          this.deviceListchange(data[k].children)
        } else {
          data[k].device.name = data[k].name
          this.userTableData.push(data[k].device)
        }
      }
    },
  },
  computed: {
    // 语音长度随语音秒数变化
    widthPercent(item) {
      return function(item) {
        let itemNew = Number(item)
        if (itemNew <= 2) {
          return { width: '70px' }
        } else if (itemNew >= 30) {
          return { width: '180px' }
        } else {
          return { width: (itemNew / 30) * 100 + 60 + 'px' }
        }
      }
    },
    sendVoice() {
      return store.state.accetpVoice
    },
    // 主题切换标识监听
    getTheme() {
      return store.state.theme
    },
    sosVoice() {
      return store.state.sosVoice
    },
  },
  mounted() {
    var that = this
    // 监听滚动条执行handleScroll()
    that.$nextTick(() => {
      that.toScrollBottom()
      window.addEventListener('scroll', that.handleScroll, true)
    })
    this._getVoiceList('nowadd')
    document.onkeydown = () => {
      var e = window.event
      if (e.keyCode === 17) {
        that.downCode = 1
      }
      if (e.keyCode === 13) {
        if (that.downCode === 1) {
          that.sendInputText = that.sendInputText + '\n'
          that.downCode = 0
        } else {
          if (this.listPlay.length > 0 && that.sendInputText !== '') {
            that.send_text()
          }
        }
      }
      // if ( !e.shiftKey && e.keyCode === 13) {
      //   if (that.downCode === 1) {
      //     that.sendInputText = that.sendInputText + '\n'
      //     that.downCode = 0
      //   } else {
      //     that.send_text()
      //   }
      // }
    }
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal === true) {
        this.userTableData = []
        this._getSelectList('', '')
      }
    },
    getTheme(val) {
      this.theme = val
    },
  },
  components: { Ripple, Trigger },
  beforeDestroy() {
    // 销毁监听的滚动条
    window.removeEventListener('scroll', this.handleScroll, true)
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" type="text/css" scoped>

#voice-broadcast .message-alert:after {
  position: absolute;
  top: calc(50% - 9px);
  width: 0;
  height: 0;
  right: -10px;
  content: ' ';
  border-left: 10px solid #1485ee;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}
#voice-broadcast .info-chat {
  position: relative;
  margin-right: 8px;
}
#voice-broadcast .info-chat:after {
  position: absolute;
  top: calc(50% - 9px);
  width: 0;
  height: 0;
  right: -10px;
  content: ' ';
  border-left: 10px solid #1485ee;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}
#voice-broadcast .info-chat-trigger {
  height: 40px !important;
  line-height: 40px !important;
}
#voice-broadcast .wifi-symbol-right {
  top: -5px !important;
}
#voice-broadcast .send-text-btn {
  position: absolute;
  right: 5px;
  top: 12px;
  cursor:pointer
}
</style>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl';
#voice-broadcast
  height 100%
  .send-text-btn
    width: 107px;
    height: 107px;
  .input-text /deep/ .el-textarea textarea
    caret-color: #1485ee;
    border: none;
    font-size: 16px;
    resize: none;
    padding-top: 14px;
    background: var(--pop-main-bg) !important;
    height: 107px;
  .input-type div
    cursor: pointer;
    width: 35%;
    height: 24px;
    background: var(--pop-log-title-bg);
    border-radius: 4px 4px 0px 0px;
    user-select: none;
    span
      font-size: 13px;
      font-weight: 400;
      color: #1485ee;
      padding: 3px;
    img
      width 16px
      height 16px
      vertical-align: middle;
.voice
  height 100%
  .conver-title
    display: flex;
    justify-content: space-between;
    font-size: 20px;
    padding: 15px;
    .add
      img
        width: 24px;
        height: 24px
  .el-container
    height calc(100% - 50px)
  .search
    text-align: center
#audio
  display: none

.log-title
  display flex
  justify-content: space-between
  align-items: center
  height: 50px;
  border-radius: 4px 4px 0px 0px;
  padding-left: 22px
  .title-name
    color: #222;
  span
    line-height: 50px
    font-size: 20px;
    color: var(--voice-broadcast-title);
    font-weight: 600;
  .groupArr
    display: inline-block;
    width: 24px;
    height: 24px;
    margin-left: 10px;
  .group-light
    bg-image-full('~@/icon/group.png');
  .group-dark
    bg-image-full('~@/icon/ic_group.png');
  .close-voice
    display flex
    align-items: center
    height: 30px
    padding 5px 10px
    border-radius: 4px
    margin-right 10px
    cursor: pointer
    .close
      width 20px
      height 20px
      margin-right 6px
    span
      font-size: 14px
      font-weight: 500;
#log
  height: calc(100% - 120px)
  .chat
    height: calc(100% - 25px);
    overflow: auto;
    padding: 0 20px
    .waveform
      margin-top: 30px
      .message-row-left
        display: flex;
        flex-direction: row;
        align-items: center
      .message-row-right
        display: flex;
        flex-direction: row-reverse;
        align-items: center
      .text-chat
        position relative
      .info-chat
        position relative
        .audio__trigger
          color #fff
      .nick-time
        position absolute
        top -20px
        right -5px
        width 110px;/*no*/
        font-size: 12px;
        margin-right: 5px;
      .portrait
        width: 40px;
        height: 40px
        margin: 0 10px;
        border-radius: 8px;
        font-size: 20px;
        text-align: center;
        line-height: 40px;
        bg-image-full('~@/icon/voice/head_port.png')
      .message-alert
        background: #1485ee;
        font-size: 0.08333333rem;
        font-weight: 400;
        color: #fff;
        padding: 10px;
        line-height: 0.10416667rem;
        border-radius: 0.02083333rem;
        position: relative;
        margin-right: 8px;
        width: fit-content
        word-wrap:break-word;
        word-break:break-all;
        max-width: 270px
    .message-nodata
      position: absolute;
      top: 0px;
      left: 50%;
      transform: translate(-50%, 0);
      font-size: 12px;
  .chat::-webkit-scrollbar
    width: 5px;
.talk
  margin: 0px auto;
  position: relative;
  height: 118px;
  .play-icon
    width: 118px;
    height: 118px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  .play-light
    bg-image-full('~@/icon/voice/record_btn.png');
    cursor:pointer
  .play-dark
    bg-image-full('~@/icon/voice/ic_record_btn.png')
  .loader
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  .endPlay-light
    bg-image-full('~@/icon/voice/record_end.png');
  .endPlay-dark
    bg-image-full('~@/icon/voice/ic_record_end.png');
  .send-cancel
    text-align: center
    .send-btn
      width: 117px;
      height: 117px;
    .cancel-btn
      width: 107px;
      height: 107px;
    .send-btndark
      width: 107px;
      height: 107px;
    .cancel-btndark
      width: 115px;
      height: 115px;
  .row-btn
    display: inline-block;
  .stop-talk
    position: absolute;
    left: 50%;
    top: 88%;
    transform: translate(-50%, 0);
    font-size: 12px;
    color: #FF0040;
.input-box
  margin: 10px auto;
// 深色模式样式覆盖
.theme-dark
  .log-title

    .close-voice
      background #021B5C
      span
        color #00E4FF
    .title-name
      color #00E4FF
  .input-type div
    span
      color #1485EE
  #log
    .chat
      .waveform
        .nick-time
          color #fff
</style>
